import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import "./confirm.css";

const ConfirmContext = createContext({ confirm: async () => false });

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({
    open: false,
    title: "",
    description: "",
    confirmText: "Confirm",
    cancelText: "Cancel",
    resolve: null,
  });

  const confirm = useCallback((opts = {}) => {
    return new Promise((resolve) => {
      setState({
        open: true,
        title: opts.title ?? "Are you sure?",
        description: opts.description ?? "",
        confirmText: opts.confirmText ?? "Confirm",
        cancelText: opts.cancelText ?? "Cancel",
        resolve,
      });
    });
  }, []);

  const onClose = useCallback((result) => {
    setState((prev) => {
      prev.resolve?.(result);
      return { ...prev, open: false, resolve: null };
    });
  }, []);

  const value = useMemo(() => ({ confirm }), [confirm]);

  return (
    <ConfirmContext.Provider value={value}>
      {children}
      {state.open && (
        <div className="tv-confirm-backdrop" role="dialog" aria-modal="true">
          <div className="tv-confirm">
            <div className="tv-confirm-title">{state.title}</div>
            {state.description && <div className="tv-confirm-desc">{state.description}</div>}
            <div className="tv-confirm-actions">
              <button className="tv-btn tv-btn-ghost" onClick={() => onClose(false)}>{state.cancelText}</button>
              <button className="tv-btn tv-btn-danger" onClick={() => onClose(true)}>{state.confirmText}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  return useContext(ConfirmContext);
}
